import { InputFieldAttributes } from "@swiggy-private/core-ui";
import { ADD_NEW_CARD_TEST_IDS } from "@swiggy-private/payment-test-ids";
import { TEXTS } from "@payment-ui/constants/index";

export const cardInputs = {
    cardNumber: {
        attrs: {
            autoComplete: "off",
            "data-testid": ADD_NEW_CARD_TEST_IDS.CARD_NUMBER,
            "data-disable-copy-paste": "true",
        },
        errorLabel: TEXTS.INVALID_CARD_NUMBER,
        label: TEXTS.CARD_NUMBER,
        maxLength: 23,
        name: "cardNumber",
        type: "tel",
    },
    cvv: {
        attrs: {
            autoComplete: "off",
            pattern: "[0-9]*",
            inputMode: "numeric",
            "data-testid": ADD_NEW_CARD_TEST_IDS.CVV,
            "data-disable-copy-paste": "true",
        } as InputFieldAttributes,
        errorLabel: TEXTS.INVALID_CVV,
        label: TEXTS.CVV,
        maxLength: 4,
        name: "cvv",
        type: "password",
    },
    expiry: {
        attrs: {
            autoComplete: "off",
            "data-testid": ADD_NEW_CARD_TEST_IDS.EXPIRY,
            "data-disable-copy-paste": "true",
        },
        errorLabel: TEXTS.INVALID_EXPIRY_DATE,
        label: TEXTS.VALID_THROUGH,
        maxLength: 5,
        name: "expiry",
        type: "tel",
    },
    name: {
        attrs: {
            autoComplete: "cc-name",
            "data-testid": ADD_NEW_CARD_TEST_IDS.CARD_HOLDER_NAME,
        },
        label: TEXTS.NAME_ON_THE_CARD,
        errorLabel: TEXTS.INVALID_CARD_NAME,
        maxLength: 50,
        name: "name",
        type: "text",
    },
    nickName: {
        attrs: {
            "data-testid": ADD_NEW_CARD_TEST_IDS.CARD_HOLDER_NICKNAME,
        },
        label: TEXTS.CARD_NICKNAME,
        errorLabel: TEXTS.INVALID_NICKNAME,
        maxLength: 50,
        name: "nickName",
        type: "text",
    },
};
